module.exports = __webpack_public_path__ + "static/travel-812ca28a611f90ff773f91d8afd4cf79.png";